
define('modules/application/wizard/classes/mainControlUnitWithRemoteControls',["app",

    // Libs
    "backbone",

    //Classes
    "./genericElement"
  ],

  function(app, Backbone, genericElement) {

    var remoteControlModel = Backbone.Model.extend({

      initialize: function() {
        this.set("products", undefined);
        if (!this.get("value"))
          this.set("value", 0);

        this.unbind("change:value", this.valueChangedEventHandler);
        this.bind("change:value", this.valueChangedEventHandler, this);
      },

      decrementValue: function() {
        var currentValue = this.get("value");
        if (currentValue - 1 >= 0) {
          this.set("value", (currentValue - 1));
        }
      },

      incrementValue: function() {
        var currentValue = this.get("value");
        this.set("value", (currentValue + 1));
      },

      resetValue: function() {
        this.set("value", 0);
      },

      valueChangedEventHandler: function() {
        this.trigger("value:changed");
        this.get("sectionEventAggregator").trigger("value:changed");
      }
    });

    var remoteControlView = Backbone.View.extend({
      tagName: "section",
      className: "remoteControl",
      template: "application/wizard/sections/mainControlUnitWithRemoteControls/item",
      events: {
        "click .ui-spinner-down": "decrementValue",
        "click .ui-spinner-up": "incrementValue"
      },

      serialize: function() {
        return {
          model: this.model,
          app: app
        };
      },

      initialize: function() {
        this.model.unbind("value:changed", this.updateSpinners);
        this.model.bind("value:changed", this.updateSpinners, this);
      },

      decrementValue: function() {
        this.model.decrementValue();
      },

      incrementValue: function() {
        this.model.incrementValue();
      },

      updateSpinners: function() {
        this.$el.find(".mainValue .spinner").html(this.model.get("value"));
      }
    });

    var remoteControlPackageModel = Backbone.Model.extend({

      initialize: function() {
        this.retrieveProducts();
      },

      retrieveProducts: function() {
        var that = this;
        BticinoS4B.Instances.Models.ApplicationModel.getProducts(this.get("packageClassId"), function(data) {
          data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
          that.set("products", _.filter(data.products, function(product) {
            return (product.mnemonic === 1);
          }).splice(0, 1));

          var products = _.extend(that.get("products")),
            productsLength = products ? products.length : 0;
          var productsToReAdd = [];
          var eventAggregator = that.get("sectionEventAggregator");
          for (var i = 0; i < productsLength; i++)
            productsToReAdd.push(new remoteControlModel(_.extend(_.extend(that.attributes, products[i]), {
              sectionEventAggregator: eventAggregator
            })));

          that.set("products", productsToReAdd);

          var secondaryProducts = _.filter(data.products, function(product) {
            return (product.mnemonic !== 4);
          })[0];

          that.set("secondaryProducts", secondaryProducts);
        });
      },

      assignValues: function(value) {
        var products = this.get("products"),
          productsLength = products ? products.length : 0;
        for (var i = 0; i < productsLength; i++) {
          products[i].set("value", value);
        }
      },

      resetProductsValue: function() {
        var products = this.get("products"),
          productsLength = products ? products.length : 0;
        for (var i = 0; i < productsLength; i++) {
          products[i].resetValue();
        }
      }
    });

    var remoteControlPackageView = Backbone.View.extend({
      tagName: "section",
      className: "remoteControlPackage",

      serialize: function() {
        return {
          model: this.model,
          app: app
        };
      },

      beforeRender: function() {
        var products = this.model.get("products"),
          productsLength = products ? products.length : 0;
        for (var i = 0; i < productsLength; i++)
          this.insertView(new remoteControlView({
            model: products[i]
          }));
      }

    });

    var mainControlUnitWithRemoteControls = _.extend({}, genericElement, {

      Views: {

        titleBar: genericElement.Views.titleBar.extend({
          template: "application/wizard/sections/mainControlUnitWithRemoteControls/titleBar",
          tagName: "h3",
          events: {
            "click": "titleBarClickedEventHandler"
          },

          initialize: function() {
            this.model.unbind("updateViews", this.setLabel);
            this.model.bind("updateViews", this.setLabel, this);
            this.model.get("sectionEventAggregator").unbind("value:changed", this.setLabel);
            this.model.get("sectionEventAggregator").bind("value:changed", this.setLabel, this);
            this.model.titleBarView = this;
            this.model.set('caption','');
          },

          setLabel: function() {
            var captionToInsert,
              packageClassLabel,
              isPartOfKit,
              remotes,
              products,
              productsLength,
              remotesTypeLabel,
              remotesLength,
              remotesAmount,
              remotesType;

            if (this.model) {
              packageClassLabel = this.model.get("packageClassLabel");
              isPartOfKit = this.model.get("partOfKit");
              remotes = this.model.get("remotes");
              remotesLength = remotes ? remotes.length : 0;
              remotesAmount = 0;

              if (!isPartOfKit) {
                captionToInsert = $.i18n._(packageClassLabel);
              } else {
                captionToInsert = $.i18n._(packageClassLabel) + " (KIT)";
              }

              for (var i = 0; i < remotesLength; i++) {
                if (i === 0)
                  remotesType = remotes[i].get("type");

                products = remotes[i].get("products");
                productsLength = products ? products.length : 0;

                for (var j = 0; j < productsLength; j++) {
                  remotesAmount += products[j].get("value");
                }
              }

              if (remotesAmount > 0) {
                if (remotesType === "tp")
                  remotesTypeLabel = "IDS_WAI1001_9004";
                else if (remotesType === "ir")
                  remotesTypeLabel = "IDS_WAI1001_9005";

                captionToInsert += " - " + remotesAmount + " " + $.i18n._(remotesTypeLabel);
              }

              if (packageClassLabel !== null && packageClassLabel !== "") {
                this.model.titleBarView.$el.find(".titleBarcontent span").html(captionToInsert);

                if (isPartOfKit)
                  this.model.titleBarView.$el.find(".titleBarcontent span").css("color", "#a0a2a3");

                this.model.titleBarView.$el.find(".titleBarcontent span").fadeIn(200);
              } else
                this.model.titleBarView.$el.find(".titleBarcontent span").fadeOut(200, function() {
                  $(this).hide();
                });
              this.model.set('caption',captionToInsert);
            }
          },

          removeLabel: function() {
            this.$el.find(".titleBarcontent span").fadeOut(200, function() {
              $(this).hide();
            });
          },

          enable: function() {
            this.$el.trigger("click");
          },

          disable: function() {
            this.$el.trigger("click");
          },

          onClose: function() {
            this.model.unbind("updateViews", this.setLabel);
          }
        }),

        content: genericElement.Views.content.extend({
          template: "application/wizard/sections/mainControlUnitWithRemoteControls/content",
          className: "mainControlUnit",

          events: {
            "change #mainControlUnit": "mainControlUnitChanged",
            "change .contactZoneSelector": "contactZoneSelectorChanged",
            "click .toggleInfoButton": "toggleInfos",
            "click .radio": "typeSelectorChangedEventHandler",
          },

          serialize: function() {
            return {
              model: this.model,
              app: app
            };
          },

          initialize: function() {
            this.model.set("view", this);
            this.model.set("contentView", this);
            this.model.unbind("updateViews", this.render);
            this.model.bind("updateViews", this.render, this);

            window.BticinoS4B.eventAggregator.unbind("mainControlUnit:changeApproved", this.completeMainControlUnitChange);
            window.BticinoS4B.eventAggregator.bind("mainControlUnit:changeApproved", this.completeMainControlUnitChange, this);

            window.BticinoS4B.eventAggregator.unbind("mainControlUnit:changeNotApproved", this.revertMainControlUnitChange);
            window.BticinoS4B.eventAggregator.bind("mainControlUnit:changeNotApproved", this.revertMainControlUnitChange, this);

            this.model.unbind("render:requested", this.render);
            this.model.bind("render:requested", this.render, this);

            this.model.unbind("change:type", this.render);
            this.model.bind("change:type", this.typeChangedEventHandler, this);

            if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"))
              this.model.accessoryLineChosenEventHandler(BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
          },

          toggleInfos: function(e) {
            return genericElement.Views.content.prototype.toggleInfos(e, this);
          },

          disableSection: function(force) {
            if (!this.model.get("enabled") || ((force !== undefined) && (force === true))) {
              this.$el.find("#mainControlUnit option").removeAttr("selected");
              this.$el.find("#mainControlUnit").attr("disabled", "disabled");
              this.$el.find("#mainControlUnit").removeAttr("rel");
              this.$el.find("span").remove();
              this.$el.find(".exampleImage").attr("src", "");
              this.$el.find(".description").html("");
              this.$el.find(".linkContainer").html("");
              window.customizeFormElements.call();
              this.hideDetails();
            }
          },

          typeChangedEventHandler: function(model) {
            this.$el.find("input").removeAttr("rel");
            this.$el.find("input").removeAttr("checked");

            this.$el.find("input[value='" + this.model.get("type") + "']").attr('checked', true);
            this.$el.find(".radio").remove();
            window.customizeFormElements.call();
          },

          contactZoneSelectorChanged: function(e) {
            var contactToConnect = e.target.name.replace("zoneSelector-", ""),
              zoneToConnect = e.target.value;
            this.model.connectToZone(contactToConnect, zoneToConnect);
          },

          enableSection: function() {
            if (this.model.get("enabled")) {
              this.$el.find("select#mainControlUnit").removeAttr("disabled");
              this.$el.find("span#selectmainControlUnit").removeClass("disabled");
              //this.showDetails();
            }
            if (!this.model.get("remoteControlsEnabled"))
              this.$el.find(".mainValue").addClass("disabled");
          },

          populateDropDown: function(mcus) {
            var dropDownView = this.$el.find("select#mainControlUnit");
            dropDownView.children("option:first").attr("selected", "selected");
            dropDownView.children("option:not(:first)").remove();

            for (var i = 0; i < mcus.length; i++)
              dropDownView.append("<option value=\"" + mcus[i].packageClassId + "\">" + $.i18n._(mcus[i].packageClassLabel) + "</option>");
          },

          mainControlUnitChanged: function(event, _force) {
            var force = false;

            if (_force)
              force = _force;

            this.model.tryToSetNewPackageClassId(event, event.target.value, force);
          },

          completeMainControlUnitChange: function(event) {
            this.naturalHideDone = true;
            this.hideDetails();
            this.showLoader();
            var mainControlUnitId = ($(event.target).val() === "") ? undefined : $(event.target).val();
            var mainControlUnitLabel = ($(event.target).children("option:selected").text() === "") ? undefined : $(event.target).children("option:selected").text();
            this.model.set("name", mainControlUnitLabel);
            this.model.set("id", mainControlUnitId);
            this.model.set("packageClassId", mainControlUnitId);

            var systemId = window.BticinoS4B.Instances.Models.ApplicationModel.get("systemId");
            if (systemId == "#2") {
              BticinoS4B.solution.thermoregulation.inserted = true;
            }

          },

          revertMainControlUnitChange: function(event) {
            var mainControlUnitId = this.model.get("id");
            var mainControlUnitLabel = "";

            this.$el.find("#mainControlUnit").children("option").removeAttr("selected");

            var selectedMCU = _.filter(this.$el.find("#mainControlUnit").children("option"), function(mcu) {
              return mcu.value === mainControlUnitId;
            });

            if (selectedMCU.length == 1) {
              $(selectedMCU[0]).attr("selected", "selected");
              mainControlUnitLabel = selectedMCU[0].label;
            }

            this.$el.find("#selectmainControlUnit").text(mainControlUnitLabel);
          },

          typeSelectorChangedEventHandler: function(e) {
            var value = this.$el.find("input[name='remotesType']:checked").val();
            this.model.set("type", value);
          },

          showDetails: function() {
            this.$el.find(".exampleImage").fadeIn(200);
            this.$el.find(".productCode").fadeIn(200);
            this.$el.find(".description").fadeIn(200);
            this.$el.find(".linkContainer").fadeTo(200, 1);
          },

          hideDetails: function() {
            this.$el.find(".exampleImage").fadeOut(200, function() {
              $(this).hide();
            });
            this.$el.find(".productCode").fadeOut(200, function() {
              $(this).hide();
            });
            this.$el.find(".description").fadeOut(200, function() {
              $(this).hide();
            });
            this.$el.find(".linkContainer").fadeTo(200, 0);
          },

          showSelector: function() {
            this.$el.find(".remotesType").show();
          },

          hideSelector: function() {
            this.$el.find(".remotesType").hide();
          },

          selectType: function(type) {
            var choosenSelector = this.$el.find("input[val='" + type + "']").trigger("click");
            window.customizeFormElements.call();
          },

          showLoader: function() {
            this.$el.find(".mini-loader").fadeIn(200);
          },

          hideLoader: function(callback) {
            var that = this;
            this.$el.find(".mini-loader").fadeOut(200, function() {
              $(this).hide();
              callback.call(that);
            });
          },

          isOpen: function() {
            return this.$el.css("display") == "block";

          },

          beforeRender: function() {
            var i = 0;
            var subViews = this.getViews().__wrapped__;

            for (i = 0; i < subViews.length; i++)
              subViews[i].remove();

            var remoteControls = [];
            var originalRemotes = this.model.get("fetchedRemotes");

            if (originalRemotes)
              for (i = 0; i < originalRemotes.length; i++) {
                remoteControls.push(_.extend({}, originalRemotes[i]));
              }

            var remoteControlsLength = remoteControls ? remoteControls.length : 0;
            var transponders = _.filter(remoteControls, function(remotePackage) {
              return remotePackage.get("type") === "tp";
            });
            var infrareds = _.filter(remoteControls, function(remotePackage) {
              return remotePackage.get("type") === "ir";
            });

            if ((transponders.length > 0) && (infrareds.length > 0)) {
              remoteControls = this.model.get("remotes");
              remoteControlsLength = remoteControls.length;
              this.showSelector();
            } else {
              this.hideSelector();
              if (transponders.length > 0)
                this.selectType("tp");
              if (infrareds.length > 0)
                this.selectType("ir");
            }

            for (i = 0; i < remoteControlsLength; i++)
              this.insertView(new remoteControlPackageView({
                model: remoteControls[i]
              })).render();
          },

          afterRender: function() {
            var that = this;

            // this.$el.find("h4.mainTitle").html($.i18n._(this.model.get("packageClassLabel")));

            if (this.model.get("wizardChoiceDescription")) {
              if ($.i18n._(this.model.get("wizardChoiceDescription")).length > 360) {
                // this.$el.find(".description.mainElement").text($.i18n._(this.model.get("wizardChoiceDescription")).substring(0, 360));
                this.$el.find(".description.mainElement").append("<br /><br /><span class='tooltip'>" + $.i18n._("IDS_W1_9032") + " ›</span>");
                this.$el.find(".tooltip.mainElement").qtip({
                  content: $.i18n._(this.model.get("wizardChoiceDescription")),
                  show: 'click',
                  style: {
                    classes: 'ui-tooltip-shadow'
                  },
                  position: {
                    at: 'center left',
                    my: 'center right'
                  },
                  effect: function() {
                    $(this).fadeIn(200);
                  }
                });
              }
              // else
                // this.$el.find(".description.mainElement").text($.i18n._(this.model.get("wizardChoiceDescription")));
            }

            setTimeout(function() {
              window.customizeFormElements.call();
            }, 100);



          },

          onClose: function() {
            this.model.unbind("change #mainControlUnit");
            this.model.unbind("updateViews", this.setLabel);
          }
        })

      },

      Model: genericElement.Model.extend({
        defaults: {
          remoteControlsEnabled: true,
          enabled: false,
          id: undefined,

          catalogId: undefined,
          image: undefined,
          links: {
            images: [],
            papers: [],
            videos: []
          },
          price: undefined,
          productCode: undefined,
          productDescription: undefined,
          productLabel: undefined,
          maxZoneNumber: undefined,
          infoQuote: "IDS_WGENTT_000014",
          //remoteControls Type
          type              : "tp"

        },

        initialize: function() {
          var that = this;

          //Bind on accessory line selection
          window.BticinoS4B.eventAggregator.unbind('accessoryLine:chosen', this.accessoryLineChosenEventHandler);
          window.BticinoS4B.eventAggregator.bind('accessoryLine:chosen', this.accessoryLineChosenEventHandler, this);

          //Bind on accessory line removal
          window.BticinoS4B.eventAggregator.unbind('accessoryLine:removed', this.accessoryLineRemovedEventHandler);
          window.BticinoS4B.eventAggregator.bind('accessoryLine:removed', this.accessoryLineRemovedEventHandler, this);

          //Bind on materials overview model delivery request
          window.BticinoS4B.eventAggregator.unbind("modelDeliver:request", this.deliverModel);
          window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);

          window.BticinoS4B.eventAggregator.unbind("load:Project", this.loadProject);
          window.BticinoS4B.eventAggregator.bind("load:Project", this.loadProject, this);

          window.BticinoS4B.eventAggregator.unbind("mainControlUnit:addedFromKit", this.productAddedFromKitEventHandler);
          window.BticinoS4B.eventAggregator.bind("mainControlUnit:addedFromKit", this.productAddedFromKitEventHandler, this);

          window.BticinoS4B.eventAggregator.unbind("removeKitItems", this.removeKitItems);
          window.BticinoS4B.eventAggregator.bind("removeKitItems", this.removeKitItems, this);

          window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);

          this.unbind("change:id", this.idChanged);
          this.bind("change:id", this.idChanged);

          this.unbind("change:type", this.filterRemoteControlsPackages);
          this.bind("change:type", this.filterRemoteControlsPackages, this);

          this.unbind("change:loadedModel", this.changeLoadedModelEventHandler);
          this.bind("change:loadedModel", this.changeLoadedModelEventHandler, this);

          //Bind on main control unit selection
          this.attributes.stepEventAggregator.bind('mainControlUnit:chosen', function(mainControlUnitId) {
            that.set("remoteControlsEnabled", true);
            that.retrievePackages(mainControlUnitId);
            that.trigger("render:requested");
          });

          //Bind on main control unit removal
          this.attributes.stepEventAggregator.bind('mainControlUnit:removed', function() {
            that.set("remoteControlsEnabled", false);
            that.disableSection();
            that.trigger("render:requested");
          });

          var eventAggregator = _.extend({}, Backbone.Events);
          this.set("sectionEventAggregator", eventAggregator);

        },

        changeLoadedModelEventHandler: function(e) {
          if (this.get("loadedModel"))
            this.filterRemoteControlsPackages();
        },

        filterRemoteControlsPackages: function() {
          var i                  = 0;
          var type               = this.get("type");
          var remotes            = this.get("fetchedRemotes");
          var currentModelToLoad = this.get("loadedModel");

          var filteredRemotes    = _.filter(remotes, function(remote) {
            remote.resetProductsValue();
            return (remote.get("type") === type);
          });

          var filteredRemotesLength = filteredRemotes.length;

          if (currentModelToLoad) {
            filteredRemotes = _.filter(remotes, function(remote) {
              return (remote.get("type") === currentModelToLoad.type);
            });

            filteredRemotesLength = filteredRemotes.length;

            for (i = 0; i < filteredRemotesLength; i++)
              if (currentModelToLoad.remotes[i])
                filteredRemotes[i].assignValues(currentModelToLoad.remotes[i].value);
              else
                filteredRemotes[i].assignValues(0);
            this.set("loadedModel", undefined);
            this.set("type", currentModelToLoad.type);
          }

          this.set("remotes", filteredRemotes);
          this.trigger("render:requested");
        },

        retrievePackages: function(mainControlUnit) {
          var that = this;
          var mcuPackageClassId = mainControlUnit.get("packageClassId");
          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(403, function(data) {
            var fetchedRemotes = data.packages;
            var fetchedRemotesLength = fetchedRemotes.length;
            var filteredRemotes = [];
            var filteredRemotesLength = 0;
            var type = "ir";
            var i;

            //Adding compatibilities to the retrieved packages
            for (i = 0; i < fetchedRemotesLength; i++) {
              switch (fetchedRemotes[i].packageClassId) {
                case "4022":
                  fetchedRemotes[i].mcuCompatibility = ["4002", "4007", "4001", "4003", "4015", "4004", "4005"];
                  fetchedRemotes[i].type = "ir";
                  break;
                case "4024":
                case "4025":
                case "4026":
                  fetchedRemotes[i].mcuCompatibility = ["4008", "4009", "4006", "4010", "4007", "4015", "4004", "4005", "4508", "4000"];
                  fetchedRemotes[i].type = "tp";
                  break;
              }
            }

            that.set("fetchedRemotes", fetchedRemotes);

            //Filter uncompatible packages
            filteredRemotes = fetchedRemotes;

            filteredRemotes = _.filter(filteredRemotes, function(remote) {
              if (_.indexOf(remote.mcuCompatibility, mcuPackageClassId) !== -1)
                return true;
              else
                return false;
            });

            filteredRemotesLength = filteredRemotes.length;
            for (i = 0; i < filteredRemotesLength; i++) {
              if (filteredRemotes[i].type === "tp") {
                type = "tp";
                break;
              }

            }

            //Retrieving products for this package
            var eventAggregator = that.get("sectionEventAggregator");
            for (i = 0; i < filteredRemotesLength; i++)
              filteredRemotes[i] = new remoteControlPackageModel(_.extend(filteredRemotes[i], {
                sectionEventAggregator: eventAggregator
              }));

            that.set("type", type, {
              silent: true
            });
            that.set("fetchedRemotes", filteredRemotes);
            that.filterRemoteControlsPackages(that.get("type"));
          });
        },

        accessoryLineChosenEventHandler: function(accessoryLineId) {
          this.fetchMCUs(accessoryLineId);
          this.set("accessoryLineId", accessoryLineId);
          this.disableSection();
          this.enableSection();
        },

        accessoryLineRemovedEventHandler: function(accessoryLineId) {
          this.set("accessoryLineId", "");
          this.removeValues();
          this.disableSection();
        },

        removeKitItems: function() {
          if (this.get("partOfKit")) {

            window.BticinoS4B.eventAggregator.trigger("contactsDisconnectionRequired");

            this.removeValues();
            this.trigger("updateViews");
            this.trigger("render:requested");
          }
        },

        productAddedFromKitEventHandler: function(addedMainControlUnit) {
          this.set("partOfKit", true);
          this.set("kitValue", 1);
          this.set("id", addedMainControlUnit.packageClassId);
          this.set("packageClassId", addedMainControlUnit.packageClassId);
        },

        connectToZone: function(contactToConnect, zoneToConnect) {
          contactToConnect = this.get("specialVars").contacts[contactToConnect];
          zoneToConnect = Number(zoneToConnect);

          //window.BticinoS4B.eventAggregator.trigger("contactsDisconnectionRequired");
          window.BticinoS4B.eventAggregator.trigger("zonesWithoutOneFreePProtection:check");

          var zonesWithoutOneFreePProtection = BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreePProtection") ? BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreePProtection") : [],
            allZones = [],
            maxZoneNumber = this.get("specialVars").maxZoneNumber,
            i = 0,
            j = 0;

          for (j = 1; j <= maxZoneNumber; j++)
            allZones.push(j);

          var zonesWithFreePerimetralProtection = _.difference(allZones, zonesWithoutOneFreePProtection);

          if ($.inArray(zoneToConnect, zonesWithFreePerimetralProtection) !== -1) {

            if (contactToConnect.connectedTo) {
              if (contactToConnect.connectedTo !== zoneToConnect) {
                window.BticinoS4B.eventAggregator.trigger("contactDisconnectionRequired", {
                  contactToDisconnect: contactToConnect
                });
              }
            }

            contactToConnect.connectedTo = zoneToConnect;

            window.BticinoS4B.eventAggregator.trigger("contactConnectionRequired", {
              contactToConnect: contactToConnect,
              zoneToConnect: zoneToConnect
            });
          } else {
            alert("Zone not available");
          }
          this.trigger("render:requested");

          BticinoS4B.solution.intrusionDetection.zonesWithoutOneFreePProtection = [];
          BticinoS4B.Instances.Models.ApplicationModel.set("zonesWithoutOneFreePProtection", []);
        },

        deliverModel: function() {
          var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
              remotes = this.get("remotes"),
              product,
              that = this,
              i = 0,
              j = 0,
              attachedProducts = [];

          //valorizzazione degli attachedProducts   
          if (this.get('specialVars') && this.get('specialVars').contacts) {
            for (i = 0; i < this.get('specialVars').contacts.length;  i++) {
              attachedProducts.push(this.get('specialVars').contacts[i]);
            }
          }
        
          dataProvider.addItems("externalItems", {
            productCode: this.get("productCode"),
            productLabel: this.get("productLabel"),
            packageClassId: this.get("packageClassId"),
            packageClassLabel: this.get("packageClassLabel"),
            kitValue: this.get("kitValue"),
            partOfKit: this.get("partOfKit"),
            quantity: 1,
            price: this.get("price"),
            attachedProducts:attachedProducts,
            isArticleSystem: true,
            type : 'mainControlUnit'
          });

          if (this.get("secondaryProducts")) {
            for (i = 0; i < this.get("secondaryProducts").length; i++) {
              dataProvider.addItems("externalItems", {
                productCode: this.get("secondaryProducts")[i].productCode,
                productLabel: this.get("secondaryProducts")[i].productLabel,
                packageClassLabel: this.get("secondaryProducts")[i].packageClassLabel,
                kitValue: this.get("kitValue"),
                partOfKit: this.get("partOfKit"),
                quantity: 1,
                price: this.get("secondaryProducts")[i].price,
                isArticleSystem: true
              });
            }
          }

          BticinoS4B.solution.intrusionDetection.mainControlUnit = $.extend({}, that);
          BticinoS4B.Instances.Models.ApplicationModel.set("mainControlUnit", that);

          BticinoS4B.solution.intrusionDetection.remoteControls = $.extend({},that);
          BticinoS4B.Instances.Models.ApplicationModel.set("remoteControls", that);

          if (remotes) {
            for (i = 0; i < remotes.length; i++) {
              for (j = 0; j < remotes[i].get("products").length; j++) {
                dataProvider.addItems("externalItems", {
                  productCode: remotes[i].get("products")[j].get("productCode"),
                  productLabel: remotes[i].get("products")[j].get("productLabel"),
                  packageClassLabel: remotes[i].get("products")[j].get("packageClassLabel"),
                  quantity: remotes[i].get("products")[j].get("value"),
                  price: remotes[i].get("products")[j].get("price"),
                  isArticleSystem: true
                });
              }

              for (j = 0; j < remotes[i].get("secondaryProducts").length; j++) {
                dataProvider.addItems("externalItems", {
                  productCode: remotes[i].get("secondaryProducts")[j].productCode,
                  productLabel: remotes[i].get("secondaryProducts")[j].productLabel,
                  packageClassLabel: remotes[i].get("secondaryProducts")[j].packageClassLabel,
                  quantity: remotes[i].get("secondaryProducts")[j].value,
                  price: remotes[i].get("secondaryProducts")[j].price,
                  isArticleSystem: true
                });
              }
            }
          }

        },

        fetchMCUs: function() {
          var that = this;
          var accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");

          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(that.get("idWizardChoice"), function(data) {

            //Retrieve branch catalog id
            var branchLocalizationId = BticinoS4B.Instances.Models.ApplicationModel.get("branchLocalizationId");

            //Sorting elements by packageClassId
            that.fetchedMCUs = data.packages;

            //Converting specialData from json to object
            for (var i = 0; i < data.packages.length; i++)
              data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);

            if (that.get("view"))
              that.get("view").populateDropDown(that.fetchedMCUs);
          });
        },

        getPackageDetails: function(packageClassId) {
          var that = this;

          if (packageClassId !== undefined) {
            accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageClassId, function(data) {
              data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              var mainProduct = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              });

              if (mainProduct.length > 0)
                mainProduct = mainProduct[0];

              _.extend(that.attributes, mainProduct);

              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });

              that.set("secondaryProducts", secondaryProducts);

              that.set("maxZoneNumber", that.get("specialVars").maxZoneNumber);
              //messo limite 19 per thermoregulation perchè Giorgio ha chiesto così in data 10/06/2014
              switch (BticinoS4B.vars.system.id) {
                case '#2':
                  if(that.get("specialVars").maxZoneNumber==99){
                    BticinoS4B.solution.thermoregulation.maxZoneNumber = 19;
                    that.set("maxZoneNumber",19);
                  }else
                    BticinoS4B.solution.thermoregulation.maxZoneNumber = that.get("maxZoneNumber");
                  break;
                case '#4':
                  BticinoS4B.solution.intrusionDetection.maxZoneNumber = that.get("maxZoneNumber");
                  break;
                case '#5+6':
                  BticinoS4B.solution.audioVideo.maxZoneNumber = that.get("maxZoneNumber");
                  break;
                case '#13+20':
                  BticinoS4B.solution.automation.maxZoneNumber = that.get("maxZoneNumber");
                  break;
              }
              BticinoS4B.Instances.Models.ApplicationModel.set("maxZoneNumber", that.get("maxZoneNumber"));

              if (that.get("id") !== undefined) {
                that.get("stepEventAggregator").trigger("mainControlUnit:chosen", that);
                window.BticinoS4B.eventAggregator.trigger("mainControlUnit:chosen", that);
                that.trigger("updateViews");

              } else {
                this.get("stepEventAggregator").trigger("mainControlUnit:removed");
                window.BticinoS4B.eventAggregator.trigger("mainControlUnit:removed", that);
                that.trigger("updateViews");
              }

              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            });
          } else {
            this.get("stepEventAggregator").trigger("mainControlUnit:removed");
            window.BticinoS4B.eventAggregator.trigger("mainControlUnit:removed");
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          }
        },

        idChanged: function(e) {
          var that = this;
          var selectedMCU = _.filter(_.extend({}, this.fetchedMCUs), function(mcu) { return mcu.packageClassId == that.id; });

          if (selectedMCU.length === 0)
            BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(that.get("id"), function(data) {
              _.extend(that.attributes, data);
              that.getPackageDetails(that.get("id"));
              that.trigger("updateViews");
            });
          else {
            _.extend(that.attributes, selectedMCU[0]);
            that.getPackageDetails(selectedMCU[0].packageClassId);
            that.trigger("updateViews");
          }

          var mergeContactData = function(data) {
            data.specialVars = JSON.parse(data.specialVars);
            data.mainControlUnitEventAggregator = _.extend({}, Backbone.Events);
            contacts[i] = data;

            contacts[i].mainControlUnitEventAggregator.bind("render:requested", function() {
              this.trigger("render:requested");
            }, that);

            contacts[i].mainControlUnitEventAggregator.bind("zoneNumber:changed", function(newZoneNumber) {
              this.connectedTo = newZoneNumber;
              this.mainControlUnitEventAggregator.trigger("render:requested");
            }, contacts[i]);
          };

          window.BticinoS4B.eventAggregator.trigger("contactsDisconnectionRequired");

          var zonesWithoutOneFreePProtection = [],
            allZones = [],
            maxZoneNumber = 0,
            i = 0,
            j = 0;

          var zonesWithFreePerimetralProtection = _.difference(allZones, zonesWithoutOneFreePProtection);

          if (this.get("specialVars").contacts)
            for (i = 0, contacts = this.get("specialVars").contacts, contactsLength = contacts.length; i < contactsLength; i++) {
              window.BticinoS4B.eventAggregator.trigger("zonesWithoutOneFreePProtection:check");

              if (typeof contacts[i] !== "object")
                BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(contacts[i], mergeContactData);

              maxZoneNumber = this.get("specialVars").maxZoneNumber;
              allZones = [];
              for (j = 1; j <= maxZoneNumber; j++)
                allZones.push(j);
              zonesWithoutOneFreePProtection = BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreePProtection") ? BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreePProtection") : [];
              zonesWithFreePerimetralProtection = _.difference(allZones, zonesWithoutOneFreePProtection);
              this.connectToZone(i, zonesWithFreePerimetralProtection[0]);
            }

          this.trigger("updateViews");
        },

        disableSection: function() {
          var that = this;

          if (this.get("enabled")) {
            this.set("enabled", false);
            this.get("view").disableSection();
            this.titleBarView.removeLabel();
            if (this.get("view").isOpen()) this.titleBarView.disable();
          }

          this.set("remoteControlsEnabled", false);
          this.get("contentView").disableSection();
          this.titleBarView.removeLabel();
          if (this.get("contentView").isOpen())
            this.titleBarView.disable();

          this.set("id", undefined);
        },

        enableSection: function() {
          var that = this;
          if (!this.get("enabled")) {
            this.set("enabled", true);
            this.get("view").enableSection();

            this.set("remoteControlsEnabled", true);
            this.get("contentView").enableSection();
          }
        },

        removeValues: function() {
          this.set("image", "");
          this.set("links", {
            images: [],
            papers: [],
            videos: []
          });
          this.set("mnemonic", "");
          this.set("name", "");
          this.set("optionalPackages", "");
          this.set("packageActuator", "");
          this.set("packageClassId", "");
          this.set("packageClassLabel", "");
          this.set("packageInDepth", "");
          this.set("packageLoad", "");
          this.set("price", "");
          this.set("productCode", "");
          this.set("productInDepth", "");
          this.set("productLabel", "");
          this.set("productDescription", "");
          this.set("wizardChoiceDescription", "");
          this.set("wizardChoiceLabel", "");
          this.set("packageClassDescription", "");
          this.set("packageClassId", "");
          this.set("packageClassLabel", "");
          this.set("partOfKit", false);
          this.set("specialVars", "");
          this.set("id", "");
          window.BticinoS4B.eventAggregator.trigger("contactsDisconnectionRequired");
        },

        loadProject: function(model) {
          var mainControlUnit = model.mainControlUnit;
          var remoteControls = model.remoteControls;

          if (mainControlUnit) {
            this.set("id", mainControlUnit.packageClassId);
            this.set("partOfKit", mainControlUnit.partOfKit);
            this.set("kitValue", mainControlUnit.kitValue);


            if (mainControlUnit.contacts && mainControlUnit.contacts.length > 0) {
              var actualContacts = this.get("specialVars").contacts;
              if (actualContacts)
                for (var i = actualContacts.length - 1; i >= 0; i--) {
                  actualContacts[i].connectedTo = mainControlUnit.contacts[i].connectedTo;
                }
            }
            this.trigger("render:requested");

          }

          if (remoteControls) {
            this.set("loadedModel", remoteControls);
          }
        },

        onClose: function() {
          this.unbind("change:id");
        },

        deliverCurrent: function() {
          var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
          if (this.get("specialVars") && consumptionIndicatorModel) {
            var currentConsumption = this.get("specialVars").currentConsumption;

            if (currentConsumption < 0)
              consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
            else
              consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
          }
        },

        tryToSetNewPackageClassId: function(event, newPackageClassId, _force) {
          var choosenMCU = _.filter(this.fetchedMCUs, function(mcu) {
            return mcu.packageClassId === newPackageClassId;
          })[0],
            force = false;

          if (_force)
            force = _force;

          if (choosenMCU)
            window.BticinoS4B.eventAggregator.trigger("mainControlUnit:selected", this.model, event, choosenMCU.specialVars.maxZoneNumber, force);
        }

      })

    });

    // Required, return the module for AMD compliance
    return mainControlUnitWithRemoteControls;

  });